import React from 'react';
import './../Styles/Footer.css';

export const Footer = () => {
    return (
        <div className="footer">
            <p>
                🖤Created by <a href='https://github.com/pipetboy2001'>Pipetboy</a>🖤
            </p>
        </div>
    );
};
